/**
 * @generated SignedSource<<5ad9d1719b1000d014e3db5d4e26f842>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type listOptions_softwareReleasesVersionDetailIssueList$data = {
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionDetailIssueList_FiltersAsync">;
  readonly " $fragmentType": "listOptions_softwareReleasesVersionDetailIssueList";
};
export type listOptions_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: listOptions_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"listOptions_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "listOptions_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesVersionDetailIssueList_FiltersAsync"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "72816e24a790f41b4c2b45bd06ad26f9";

export default node;
